export const links = {
  landing: ({ interfaceLanguage }: { interfaceLanguage: string }): string =>
    `/${interfaceLanguage}`,

  app: ({ interfaceLanguage }: { interfaceLanguage: string }): string =>
    `/${interfaceLanguage}/app`,

  profile: ({ interfaceLanguage }: { interfaceLanguage: string }): string =>
    `/${interfaceLanguage}/profile`,

  bookmarks: ({ interfaceLanguage }: { interfaceLanguage: string }): string =>
    `/${interfaceLanguage}/bookmarks`,

  settings: ({ interfaceLanguage }: { interfaceLanguage: string }): string =>
    `/${interfaceLanguage}/settings`,

  wordOfTheDay: ({
    interfaceLanguage,
  }: {
    interfaceLanguage: string;
  }): string => `/${interfaceLanguage}/word-of-the-day`,

  flashcards: ({ interfaceLanguage }: { interfaceLanguage: string }): string =>
    `/${interfaceLanguage}/flashcards`,

  quizzes: ({ interfaceLanguage }: { interfaceLanguage: string }): string =>
    `/${interfaceLanguage}/quizzes`,

  dailyChallenge: ({
    interfaceLanguage,
  }: {
    interfaceLanguage: string;
  }): string => `/${interfaceLanguage}/daily-challenge`,

  achievements: ({
    interfaceLanguage,
  }: {
    interfaceLanguage: string;
  }): string => `/${interfaceLanguage}/achievements`,

  leaderboard: ({ interfaceLanguage }: { interfaceLanguage: string }): string =>
    `/${interfaceLanguage}/leaderboard`,

  about: ({ interfaceLanguage }: { interfaceLanguage: string }): string =>
    `/${interfaceLanguage}/about`,

  advancedSearch: ({
    interfaceLanguage,
  }: {
    interfaceLanguage: string;
  }): string => `/${interfaceLanguage}/search/advanced`,

  // Learning system links
  learn: ({ interfaceLanguage }: { interfaceLanguage: string }): string =>
    `/${interfaceLanguage}/learn`,

  learnWords: ({ interfaceLanguage }: { interfaceLanguage: string }): string =>
    `/${interfaceLanguage}/learn/words`,

  learnVocabulary: ({ interfaceLanguage }: { interfaceLanguage: string }): string =>
    `/${interfaceLanguage}/learn/vocabulary`,

  learnProgress: ({ interfaceLanguage }: { interfaceLanguage: string }): string =>
    `/${interfaceLanguage}/learn/progress`,

  learnLessons: ({
    interfaceLanguage,
  }: {
    interfaceLanguage: string;
  }): string => `/${interfaceLanguage}/learn/lessons`,

  learnPractice: ({
    interfaceLanguage,
  }: {
    interfaceLanguage: string;
  }): string => `/${interfaceLanguage}/learn/practice`,

  learnTest: ({ interfaceLanguage }: { interfaceLanguage: string }): string =>
    `/${interfaceLanguage}/learn/test`,

  simplePage: ({
    interfaceLanguage,
    pageName,
  }: {
    interfaceLanguage: string;
    pageName: string;
  }): string => `/${interfaceLanguage}/${pageName}`,

  language: ({
    interfaceLanguage,
    learningLanguage,
  }: {
    interfaceLanguage: string;
    learningLanguage: string;
  }): string => `/${interfaceLanguage}/${learningLanguage}`,

  tag: ({
    interfaceLanguage,
    learningLanguage,
    tagSlug,
  }: {
    interfaceLanguage: string;
    learningLanguage: string;
    tagSlug: string;
  }): string =>
    `/${interfaceLanguage}/${learningLanguage}/words/tags/${tagSlug}`,

  search: ({
    interfaceLanguage,
    learningLanguage,
  }: {
    interfaceLanguage: string;
    learningLanguage: string;
  }): string => `/${interfaceLanguage}/${learningLanguage}/search`,

  word: ({
    interfaceLanguage,
    learningLanguage,
    wordId,
    wordSlug,
  }:
    | {
        interfaceLanguage: string;
        learningLanguage: string;
        wordId: string;
        wordSlug?: string;
      }
    | {
        interfaceLanguage: string;
        learningLanguage: string;
        wordSlug: string;
        wordId?: string;
      }): string =>
    `/${interfaceLanguage}/${learningLanguage}/words/${wordId || wordSlug}`,

  login: ({ returnTo }: { returnTo?: string } = {}): string =>
    `/auth/login${returnTo ? `?returnTo=${encodeURIComponent(returnTo)}` : ""}`,

  logout: (): string => "/auth/logout",
};

export const buildRoute =
  <T extends Record<string, string | number | boolean>>(
    routeFn: (params: T) => string,
    predefinedParams: Partial<T> = {}
  ) =>
  (params: Omit<T, keyof typeof predefinedParams>) => {
    return routeFn({ ...predefinedParams, ...params } as T);
  };